import { AvailabilityColumns, LeaseColumns } from '@miq/catalog';
import { byNumericalFirst } from './sorting';

export type ComparisonFunction = (valueA: any, valueb: any) => number;

export const ColumnsCustomSortMap = new Map<number, ComparisonFunction>([
  [AvailabilityColumns.FloorSuite_FloorNumber, byNumericalFirst],
  [LeaseColumns.FloorSuite_Floor, byNumericalFirst],
]);
